export default "__VITE_ASSET__CYMgt3$w__"